import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Page,
  Card,
  Layout,
  SkeletonBodyText,
  Pagination,
  Toast,
  ChoiceList,
  Tabs,
  Filters,
  SkeletonPage,
  EmptyState,
  BlockStack,
  // Checkbox,Popover,ActionList,ExceptionList,Badge,Modal,Button
  Link,
  Text,
  // Box,
  // Button,
} from "@shopify/polaris";

import LazyLoad from 'react-lazyload';
import _ from "lodash";
import { 
  reqGetCustomPackagingList
} from '../../../../api';
import utils from '../../../../utils/utils'
import PackageDetailModal from './PackageDetailModal';
import '../index.css';
import intl from '../../../../i18n/intl';
import MyPacking from "./MyPacking/Index"
import AppBridge from '../../../../utils/appBridge';
class CustomPackagingClass extends Component {

  state = {
    //页面动作
    loadingPage: false,
    isSearching: '0',
    page: 1,
    size: 20,
    hasPrevious: false,
    hasNext: true,
    ShowCountNumber: 0,

    // 列表原始数据
    pageData: [],
    // DIV列表数据
    ListDivHtml: <div></div>,

    tabSelected: 0,
    queryValue: '',  // 关键词内容搜索
    filterTypeOptions: [],
    filterStatus: [],  // 类型搜索

    // package详情弹窗 (create order)
    PackageDetailContent: '',
  };

  //进入页面调用接口
  componentDidMount() {
    this.getPageData();
    if(AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar('Branding','/admin/customService',this.handleLink)
    }
  }

  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };

  // 获取列表数据
  getPageData = async(isSearch=false) =>{
    if(isSearch){
      this.setState({
        isSearching:'1',
        hasPrevious : false,
        hasNext : false,
      });
    }else{
      this.setState({
        loadingPage: true,
        hasPrevious : false,
        hasNext : false,
      });
    }
    const params = {
      q: this.state.queryValue,
      page: this.state.page,
      size: this.state.size,
      type: JSON.stringify(this.state.filterStatus),
    };
    const response = await reqGetCustomPackagingList(params);
    if(response.code==='200'){
      let getData = response.data;
      this.setState({
        loadingPage: false,
        pageData: getData.result,
        filterTypeOptions: getData.filter,
        total: getData.count,
        ShowCountNumber: getData.count,
        isSearching: '0',
      },()=>{
        // 更新列表数据
        this.updatePageDetail();
      });

      // 更新分页数据
      if(this.state.page > 1){
        this.setState({
          hasPrevious:true
        });
      }else{
        this.setState({
          hasPrevious:false
        });
      }

      const maxPage =  Math.ceil(response.data.count / this.state.size);
      if(this.state.page < maxPage){
        this.setState({
          hasNext:true
        });
      }else{
        this.setState({
          hasNext:false
        });
      }

    }else{
      this.toggleToast(response.msg);
      this.setState({
        loadingPage: false,
        pageData: [],
        isSearching: '0',
      });
    }
  }
 // 防抖
 handleFiltersQueryChangeDebounce = _.debounce(() =>{
  this.getPageData(true);
},500)
  // 更新列表信息
  updatePageDetail(){
    let data = this.state.pageData;
    let listHtmlContent = <div></div>;

    if(data.length > 0){
      listHtmlContent = data.map((item,key) => {
        let imageUrl = '/default_image.png';
        if(item.image_url !== '' && (typeof item.image_url) !=='object'){
          imageUrl = item.image_url;
        }

        return (
          <div className="Product_Card_Tkabk custom_packaging" key={key}>
            <Card padding={0}>
              <Link 
                onClick={() =>{
                  utils.routeListen('/admin/customService/custom-packaging/packaging-info?filter='+item.id)
                  utils.routeJump(this,'/admin/customService/custom-packaging/packaging-info?filter='+item.id)
              }}
                monochrome
                removeUnderline
              >
                <div className="Product_Image_Wrapper Product_Cover_Tkabk" style={{width:'246px',height:'246px'}}>
                  {/* <div className="lazyload-wrapper"> */}
                  <LazyLoad once>
                    <img src={imageUrl} alt="" />
                  </LazyLoad>
                  {/* </div> */}
                </div>

                <div style={{padding:'20px'}}>
                  <BlockStack spacing="extraTight">
                    <div className="Product_Title_tkabk" title={item.title}>
                      {item.title}
                    </div>
                    <Text  variant="bodyMd" as="span" fontWeight="semibold">{item.price +' USD'}</Text>
                    {/* <div className="Product_Discount_Row_tkabk">
                      <TextStyle variation="subdued">
                        <span className="Product_Compare_at_price_tkabk">
                          $49.97 USD
                        </span>
                      </TextStyle>
                      <Badge status="warning">-45%</Badge>
                    </div> */}
                  </BlockStack>
                  <BlockStack spacing="extraTight">
                    {/* <Stack distribution="equalSpacing">
                      <span className="Product_Rating_tkabk">
                        <svg viewBox="0 0 20 20">
                          <path d="M5.2 18a.8.8 0 0 1-.792-.914l.743-5.203-2.917-2.917a.8.8 0 0 1 .434-1.355l4.398-.733 2.218-4.435a.8.8 0 0 1 1.435.008l2.123 4.361 4.498.801a.8.8 0 0 1 .425 1.353l-2.917 2.917.744 5.203a.8.8 0 0 1-1.154.828l-4.382-2.22-4.502 2.223A.792.792 0 0 1 5.2 18z"></path>
                        </svg>
                        4.8(45K)
                      </span>
                      <span className="Product_Orders_tkabk">
                        <svg viewBox="0 0 20 20">
                          <path d="M11 1a1 1 0 1 0-2 0v7.586L7.707 7.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L11 8.586V1z"></path>
                          <path d="M3 14V3h4V1H2.5A1.5 1.5 0 0 0 1 2.5v15A1.5 1.5 0 0 0 2.5 19h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 17.5 1H13v2h4v11h-3.5c-.775 0-1.388.662-1.926 1.244l-.11.12A1.994 1.994 0 0 1 10 16a1.994 1.994 0 0 1-1.463-.637l-.111-.12C7.888 14.664 7.275 14 6.5 14H3z"></path>
                        </svg> 
                        151.8K
                      </span>
                    </Stack> */}
                    {/* <div className="Place_Order_Button">
                      <Button 
                        // onClick={()=>this.handlePackageDetailModal(item.id)}
                        url={'/admin/customService/custom-packaging/packaging-info?filter=' + item.id}
                        fullWidth 
                        primary
                      >
                        Packaging detail
                      </Button>
                    </div> */}
                  </BlockStack>
                  </div>
              </Link>
            </Card>
          </div>
        );
      });
    }

    this.setState({
      ListDivHtml: listHtmlContent,
      ShowCountNumber: data.length,
    });
  }

  // tabs 切换
  handleTabChange = (index) =>{
    this.setState({
      tabSelected: index,
    });
  }

  // filter 产品状态选项选择
  handleFilterStatusChange = (status) =>{
    this.setState({
      filterStatus: status,
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // filter 产品状态选项移除
  handleFilterStatusRemove = () =>{
    this.setState({
      filterStatus: [],
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // filter 清除所有选项选择
  handleFiltersClearAll = () =>{
    this.setState({
      queryValue: '',
      filterStatus: [],
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

 
  // 搜索输入
  handleFiltersQueryChange = (value) =>{
    this.setState({
      queryValue: value,
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // 清空搜索内容
  handleQueryValueRemove =()=>{
    this.setState({
      queryValue: '',
      page: 1,
    },()=>{
      this.handleFiltersQueryChangeDebounce()
    });
  }

  // 打开礼品详情(create order)弹窗
  handlePackageDetailModal = (id) =>{
    let content = (
      <PackageDetailModal
        show={true}
        id={id}
      />
    )

    this.setState({
      PackageDetailContent: content
    });
  }
  handleLink = ()=>{
    utils.routeListen('/admin/settings/config')
    utils.routeJump(this,'/admin/settings/config')
  }

  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} duration={1500} /> : null;
    const {
      isSearching,ShowCountNumber,ListDivHtml,PackageDetailContent,
    } = this.state;

    const initSkeletonPage = (
      <div>
         <SkeletonPage fullWidth={true}>
         <Layout>
          <Layout.Section>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
        </Layout.Section>
          </Layout>
        </SkeletonPage>
      </div>
    )

    const EmptyProductList = (ShowCountNumber===0) ? (
      <div className="emptyWithImg">
        <EmptyState
          heading={intl.get("Custom packaging list is empty")}
          image="/empty.svg"
        >
          <p style={{fontSize:'14px',opacity:'1',marginBottom:'0'}}>{intl.get('Custom packaging products are on the way, so stay tuned')}</p>
        </EmptyState>
      </div>
    ) : '';
    
    const TabSelectArray = [
      // {
      //   id: "tab-packaging-all",
      //   content: intl.get("All"),
      //   accessibilityLabel: "All packaging status",
      // },
      {
        id: "tab-packaging-my",
        content: intl.get("My Packaging"),
        accessibilityLabel: "My packaging",
      },
    ];

    const filters = [
      {
        key: 'filterStatus',
        label: intl.get('Type'),
        filter: (
          <ChoiceList
            title={intl.get('Type')}
            titleHidden
            choices={this.state.filterTypeOptions}
            selected={this.state.filterStatus || []}
            onChange={this.handleFilterStatusChange}
            allowMultiple
          />
        ),
        shortcut: true,
      },
    ];

    const appliedFilters = [];
    if (!isEmpty(this.state.filterStatus)) {
      const key = 'filterStatus';
      appliedFilters.push({
        key,
        label: disambiguateLabel(key, this.state.filterStatus,this.state.filterTypeOptions),
        onRemove: this.handleFilterStatusRemove,
      });
    }

    var footerContentMsg ='';
    if(this.state.total > 0){
      const startNum = (((this.state.page - 1) * this.state.size) + 1);
      const endNum   = (this.state.page * this.state.size>this.state.total)?this.state.total:this.state.page * this.state.size;
      // footerContentMsg = <div className="Pagination_Result__Footer">{"Showing " + startNum + " - "+ endNum + " of " + this.state.total + " results"}</div>;
      footerContentMsg = <div>{intl.get("Showing {{startNum}} - {{endNum}} of {{total}} results", startNum, endNum, this.state.total)}</div>;
    }

    const PaginationSettings = this.state.loadingPage ? '' :
      (ShowCountNumber !== 0) ?
        <div className="Polaris-New-Pagination">
          <Pagination
            label={footerContentMsg}
            hasPrevious = {this.state.hasPrevious}
            onPrevious={() => {
              this.setState(({page:this.state.page - 1}),()=>{
                  this.getPageData(true);
              });
            }}
            hasNext = {this.state.hasNext}
            onNext={() => {
              this.setState(({page:this.state.page + 1}),()=>{
                  this.getPageData(true);
              });
            }}
          />
        </div> : '';

    // 控制列表两个产品之间间距显示
    let smallSpacingClass = (ShowCountNumber <= 4) ? 'small_spacing' : '';

    const pageContent = this.state.loadingPage ? initSkeletonPage : (
      <section>
        <Page 
          title={AppBridge.exist() ? "" : <div style={{fontSize:'20px'}} >{intl.get('Branding')}</div>}
          backAction={AppBridge.exist() ? undefined : {content: 'Branding', onAction: () =>{
            utils.routeListen('/admin/customService')
            utils.routeJump(this,'/admin/customService')
            }}}
          fullWidth
          primaryAction={
            AppBridge.exist() ? undefined : {
              content: intl.get('Upload logo'),
              onAction: () =>{
                utils.routeListen('/admin/settings/config')
                utils.routeJump(this,'/admin/settings/config')
                },
            }
          }
        >
         {/* {AppBridge.exist() && <Box style={{display:'flex',justifyContent:'flex-end'}}>
            <Button variant='primary' onClick={() =>{
                utils.routeListen('/admin/settings/config')
                utils.routeJump(this,'/admin/settings/config')
                }}>{intl.get('Upload logo')}</Button>
          </Box>} */}
          <Layout>
            <Layout.Section>
              <div style={{"paddingTop":"1rem"}}></div>
              <Card>
                <Tabs
                  tabs={TabSelectArray}
                  selected={this.state.tabSelected}
                  onSelect={this.handleTabChange}
                >
                     
                  {this.state.tabSelected === 2 && <Filters
                      queryValue={this.state.queryValue}
                      queryPlaceholder={intl.get('Search title')}
                      filters={filters}
                      appliedFilters={appliedFilters}
                      onQueryChange={this.handleFiltersQueryChange}
                      onQueryClear={this.handleQueryValueRemove}
                      onClearAll={this.handleFiltersClearAll}
                    />}
                    
                    {/* 数据为空显示 */}
                    {this.state.tabSelected === 2 &&  <div style={{position:'relative'}}>

                      {EmptyProductList}

                      <div className="Product__Loading" style={{display: (isSearching==='1' && ShowCountNumber===0)?'block':'none'}}>
                        <div className="Product__Loading_Image">
                          <img style={{width:'32px',height:'32px',verticalAlign:'middle'}} src='/loading.gif' alt="loading" />
                        </div>
                      </div>
                    </div>}

                     

                </Tabs>
              </Card>

              {/* Start: custom packaging 列表 */}
              {this.state.tabSelected === 2 &&  <div style={{position:'relative'}}>

                <section className="Product_Resource_Wrapper">
                  <div className="Border_Mask Left"></div>
                  <div className="Border_Mask Right"></div>
                  <div className="Border_Mask Bottom"></div>

                  <div className={"Product_Resource_Container " + smallSpacingClass}>
                    {/* 列表 div 对象 */}
                    {ListDivHtml}
                  </div>
                </section>

                <div className="Product__Loading" style={{display: (isSearching==='1' && ShowCountNumber>0)?'block':'none'}}>
                  <div className="Product__Loading_Image">
                    <img style={{width:'32px',height:'32px',verticalAlign:'middle'}} src='/loading.gif' alt="loading" />
                  </div>
                </div>
              </div>}

              {this.state.tabSelected === 0 && <MyPacking />}
              {/* End: 列表 */}

              {/* 分页 */}
              {this.state.tabSelected === 2 && PaginationSettings}



            </Layout.Section>
          </Layout>
        </Page>
      </section>
    )

    return (
      <div>
        {/* 页面内容 */}
        {pageContent}
        {/* package 详情弹窗 (create order) */}
        {PackageDetailContent}

        {toastMarkup}
      </div>
    );

    function disambiguateLabel(key, value, options) {
      switch (key) {
        case 'taggedWith':
          return `Tagged with ${value}`;
        case 'filterStatus':
          let i,j;
          let str = [];
          for(i=0; i<value.length; i++){
            for(j=0; j<options.length; j++){
              if(value[i] === options[j].value){
                str.push(options[j].label);
              }
            }
          }
          return str.map((val) => `${val}`).join(' , ');
        default:
          return value;
      }
    }

    function isEmpty(value) {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else {
        return value === '' || value == null;
      }
    }
    
  }
}

export default withRouter(CustomPackagingClass);
